export const TITLE = 'title'

// general inputs
export const COUNTRY_ID = 'country_id'
export const TOTAL_INVESTMENT = 'total_investment'
export const TOTAL_ACTIVITY_HOURS = 'total_activity_hours'
